import { ProductPackageFilter } from '@spilca/dictionary_ts/v1/dictionary_md/product_package_pb';

import { int64, string } from '@monorepo/helpers';
import { FILTER_PARAMS } from '../../constants';

const filterProductPackageConstructor = (filterValues: any) => {
  const filter = new ProductPackageFilter();

  if (filterValues[FILTER_PARAMS.id]) {
    filter.setId(int64(filterValues[FILTER_PARAMS.id]));
  }

  if (filterValues[FILTER_PARAMS.name]) {
    filter.setProductName(string(filterValues[FILTER_PARAMS.name].toString()));
  }

  if (filterValues[FILTER_PARAMS.productId]) {
    filter.setProductId(int64(filterValues[FILTER_PARAMS.productId]));
  }

  if (filterValues[FILTER_PARAMS.quantityTypeId]) {
    filter.setQuantityTypeId(int64(filterValues[FILTER_PARAMS.quantityTypeId]));
  }

  if (filterValues[FILTER_PARAMS.state]) {
    filter.setState(filterValues[FILTER_PARAMS.state]);
  }

  if (filterValues[FILTER_PARAMS.brand]) {
    filter.setBrandName(string(filterValues[FILTER_PARAMS.brand].toString()));
  }

  if (filterValues[FILTER_PARAMS.type]) {
    // @ts-ignore
    filter.setProductType(int64(filterValues[FILTER_PARAMS.type]));
  }

  return filter;
};

export default filterProductPackageConstructor;
